import classNames from 'classnames';

/**
 * Provides a wrapper around a [classnames#bind](https://github.com/JedWatson/classnames#alternate-bind-version-for-css-modules)
 * that also supports converting class names before they are looked up in
 * the `classNameMap`.
 *
 * @param {Record<string, string>} localClassNameMap - A map of class names
 * @param {Record<string, string>} globalClassNameMap - A map of class names
 * @param {classNameConverter} classNameConverter - A callback function to convert the class name before being looked up in the class name map
 *
 * @returns {function(...[*]): string} - Returns an API equivalent to [classnames](https://github.com/JedWatson/classnames#usage), but
 * one that can also return `undefined` in the case there are no valid classes.
 */
function createClassNames(localClassNameMap, globalClassNameMap, classNameConverter) {
  if (localClassNameMap === void 0) {
    localClassNameMap = {};
  }

  if (globalClassNameMap === void 0) {
    globalClassNameMap = {};
  }

  if (classNameConverter === void 0) {
    classNameConverter = function classNameConverter(className) {
      return className;
    };
  }

  function convert(className) {
    var _ref, _localClassNameMap$co;

    var convertedClassName = classNameConverter(className);
    return (_ref = (_localClassNameMap$co = localClassNameMap[convertedClassName]) != null ? _localClassNameMap$co : globalClassNameMap[convertedClassName]) != null ? _ref : className;
  }

  return function classNamesWrapper() {
    var finalClassNames = classNames.apply(void 0, arguments).split(' ').map(convert).join(' ');
    return finalClassNames.length > 0 ? finalClassNames : undefined;
  };
}

export default createClassNames;